import { FC } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { VisualValidationGenerating } from '@atlas-frontend/sdk';
import translations from './VisualValidation.translations.json';
import { SectionContextProvider } from '../../common/SectionContext';
import { NotFound } from '../NotFound';
import { path } from '../../paths';
import { CrossTable } from './crosstable/CrossTable';
import { Helmet } from 'react-helmet-async';
import { TimeSeries } from './timeseries/TimeSeries';
import { Comparison } from './comparison/Comparison';
import { TimeSeriesComparison } from './timeseriesComparison/TimeSeriesComparison';
import { Report } from './report/Report';
import { ReportIndicatorValue } from './report/ReportIndicatorValue';

const { addTranslations, t } = i18nNsFactory('visual-validation');
addTranslations(translations);
export const tVisualValidation = t;

export const VISUAL_VALIDATION_ROUTES = [
  {
    path: '/',
    children: [
      {
        index: true,
        element: <Navigate to={path.visualValidationCrossTable} replace />,
      },
      {
        path: path.visualValidationGenerating,
        element: <VisualValidationGenerating />,
      },
      {
        path: path.visualValidationCrossTable,
        element: <CrossTable />,
      },
      {
        path: path.visualValidationTimeSeries,
        element: <TimeSeries />,
      },
      {
        path: path.visualValidationComparison,
        element: <Comparison />,
      },
      {
        path: path.visualValidationTimeSeriesComparison,
        element: <TimeSeriesComparison />,
      },
      {
        path: path.visualValidationReportIndicatorValue,
        element: <ReportIndicatorValue />,
      },
      {
        path: path.visualValidationReport,
        element: <Report />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export interface VisualValidationProps {
  basePath: string;
}

export const VisualValidation: FC<VisualValidationProps> = ({ basePath }) => (
  <SectionContextProvider basePath={basePath}>
    <Helmet>
      <title>{t('title')}</title>
    </Helmet>
    {useRoutes(onBasePath(basePath, VISUAL_VALIDATION_ROUTES))}
  </SectionContextProvider>
);
